export const OFFERS = {
  consultation: {
    page: "private-consultation",
    kicker: "New Client Introduction · Scottsdale",
    line1: "Exceptional skin,",
    line2: "transparently priced.",
    sub: "Personalized treatment plans, expert care and best practices — all under one roof. Tell us what you'd like to achieve, or book directly.",
    badge: null,
  },
  newClient: {
    page: "new-client-offer",
    kicker: "New Client Offer · Scottsdale",
    line1: "10% off",
    line2: "your first visit.",
    sub: "An invitation for new clients: enjoy 10% off when you begin with Lux Veritae. Share your goals for a personalized plan, or book your appointment directly.",
    badge: "10% off for new clients",
  },
};
